import * as constants from '../constants/completedJob-consts'
import { Job } from '../types'

export interface SetCompletedJobAction {
    type: string
    completedJob: Job | null
}

export type CompletedJobActions = SetCompletedJobAction

export function setCompletedJob(completedJob: Job): SetCompletedJobAction {
    return {
        type: constants.COMPLETED_JOB,
        completedJob
    }
}



// WEBPACK FOOTER //
// ./src/actions/setCompletedJob.ts